import{a as e}from"./chunk-73A5OTVH.js";var o=class extends e{};export{o as a};
